export default {
  items: [
    {
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'icon-speedometer',
      /*badge: {
        variant: 'info',
        text: 'NEW',
      },*/
    },
    /*{
      title: true,
      name: 'Components',
      wrapper: {
        element: '',
        attributes: {},
      },
    },*/
    {
      name: 'Users',
      icon: 'icon-user',
      children: [
        {
          name: 'Users',
          url: '/Users',
          icon: 'icon-list',
        },
        {
          name: 'User Profile',
          url: '/UserProfile',
          icon: 'icon-bell',
        }
      ],
     
    },
    {
      name: 'Levels Of Difficulty',
      url: '/LODs',
      icon: 'icon-cursor',
      
    },
    {
      name: 'Click Image Trees',
      url: '/ClickImageAnswers',
      icon: 'icon-pie-chart',
    },
    {
      name: 'Interpreted Images',
      url: '/ClickInterpretedImageAnswers',
      icon: 'icon-star'
    },
    {
      name: 'Courses',
      icon: 'icon-bell',
      children: [
        {
          name: 'Add Course',
          url: '/Courses/Add',
          icon: 'icon-bell',
        },
        {
          name: 'Courses List',
          url: '/Courses/List',
          icon: 'icon-list',
        }
      ],
    },
    {
      name: 'Keyboard',
      icon: 'icon-calculator',
      children: [
        {
          name:'Add Keyboard',
          url:'/Keyboard/AddKeyboard',
          icon:'icon-bell'
        },
        {
          name: 'Add Key',
          url: '/Keyboard/AddKey',
          icon: 'icon-bell',
        },
        {
          name: 'Keys List',
          url: '/Keyboard/KeysList',
          icon: 'icon-list',
        },
        {
          name: 'Keyboards List',
          url: '/Keyboard/KeyboardsList',
          icon: 'icon-list',
        }
      ]
    
    },
    {
      name: 'Questions',
      icon: 'icon-calculator',
      children: [
        {
          name:'Add Question',
          url:'/Questions/Add',
          icon:'icon-bell'
        },
        {
          name:'Questions List',
          url:'/Questions/List',
          icon:'icon-list'
        }
      ]
    
    },
    {
      name: 'Topics',
      url: '/Topics',
      icon: 'icon-star'
    },
    {
      name: 'Challenges',
      url: '/Challenges',
      icon: 'icon-star'
    },
    
    /*{
      name: 'Download CoreUI',
      url: 'https://coreui.io/react/',
      icon: 'icon-cloud-download',
      class: 'mt-auto',
      variant: 'success',
      attributes: { target: '_blank', rel: "noopener" },
    },
    {
      name: 'Try CoreUI PRO',
      url: 'https://coreui.io/pro/react/',
      icon: 'icon-layers',
      variant: 'danger',
      attributes: { target: '_blank', rel: "noopener" },
    },*/
  ],
};

export const admin_nav = {
  items: [
    {
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'icon-speedometer',
      badge: {
        variant: 'info',
        text: 'NEW',
      },
    },
    {
      name: 'Users',
      icon: 'icon-user',
      children: [
        {
          name: 'Users',
          url: '/Users',
          icon: 'icon-list',
        }
      ],
     
    },
    {
      name: 'Data Pools',
      icon: 'icon-list',
      children: [
        {
          name: 'Data Pools',
          url: '/DataPools',
          icon: 'icon-list',
        }
      ],
     
    },
    {
      name: 'Levels Of Difficulty',
      url: '/LODs',
      icon: 'icon-cursor',
      
    },
    {
      name: 'Ownership',
      url: '/Ownership',
      icon: 'icon-pie-chart',
    }
  ],
};

export const student_nav = {
  items: [
    {
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'icon-speedometer',
      
    }
  ],
};

export const course_nav = {
  items: [
    {
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'icon-speedometer',
    },

    {
      name: 'Profile/Colleagues',
      icon: 'icon-user',
      url: '/colleagues',     
    },
    {
      name: 'Datapools',
      icon: 'icon-lock',
      url: '/Settings',     
    },
    {
      name: 'Reports',
      icon: 'icon-report',
      url: '/Reports',     
    },
    {
      name: 'Courses',
      icon: 'icon-bell',
      children: [
        {
          name: 'Add Course',
          url: '/Courses/Add',
          icon: 'icon-bell',
        },
        {
          name: 'Add Course Map',
          url: '/Courses/AddCourseMap',
          icon: 'icon-bell',
        },
        {
          name: 'Courses List',
          url: '/Courses/List',
          icon: 'icon-list',
        }
      ],
    },{
      name: 'Notifications',
      icon: 'icon-bell',
      url: '/Notifications',     
    },{
      name: 'Student feedback',
      icon: 'icon-share-alt',
      url: '/StudentFeedback',     
    },
    {
      name: 'Questions',
      icon: 'icon-calculator',
      children: [
        {
          name:'Questions List',
          url:'/Questions/List',
          icon:'icon-list'
        }
      ]
    
    }
  ],
};

export const content_nav = {
  items: [
    {
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'icon-speedometer',
     
    },
    {
      name: 'Datapools',
      icon: 'icon-lock',
      url: '/Settings',     
    },
    {
      name: 'Profile/Colleagues',
      icon: 'icon-user',
      url: '/colleagues',     
    },
    {
      name: 'Reports',
      icon: 'icon-report',
      url: '/Reports',     
    },
    {
      name: 'Information',
      icon: 'icon-calculator',
      children: [
        {
          name:'Add information',
          url:'/Information/Add',
          icon:'icon-bell'
        },{
          name:'Information list',
          url:'/Information/List',
          icon:'icon-bell'
        },{
          name:'Add background image',
          url:'/Information/AddBI',
          icon:'icon-bell'
        },{
          name:'Background images',
          url:'/Information/ListBI',
          icon:'icon-bell'
        },{
          name:'Add map element image list',
          url:'/Information/AddMEIL',
          icon:'icon-bell'
        },{
          name:'Map element image lists',
          url:'/Information/ListMEIL',
          icon:'icon-list'
        },{
          name:'Add Series Icons',
          url: '/Information/AddSeriesIcons',
          icon:'icon-bell'
        }]
    },
    {
      name: 'Click Image Trees',
      url: '/ClickImageAnswers',
      icon: 'icon-pie-chart',
    },
    {
      name: 'Interpreted Images',
      url: '/ClickInterpretedImageAnswers',
      icon: 'icon-star'
    },
    {
      name: 'Topics',
      url: '/Topics',
      icon: 'icon-star'
    },
    {
      name: 'Keyboard',
      icon: 'icon-calculator',
      children: [
        {
          name:'Add Keyboard',
          url:'/Keyboard/AddKeyboard',
          icon:'icon-bell'
        },
        {
          name:'Add Key List',
          url:'/Keyboard/AddKeyList',
          icon:'icon-bell'
        },
        {
          name: 'Add Key',
          url: '/Keyboard/AddKey',
          icon: 'icon-bell',
        },
        {
          name: 'Keys ',
          url: '/Keyboard/KeysList',
          icon: 'icon-list',
        },
        {
          name: 'Keyboards List',
          url: '/Keyboard/KeyboardsList',
          icon: 'icon-list',
        },
        {
          name:'Keys Lists',
          url:'/Keyboard/KeysListList',
          icon:'icon-bell'
        }
      ]
    
    },
    {
      name: 'Questions',
      icon: 'icon-calculator',
      children: [
        {
          name:'Add Clickable Question',
          url:'/Questions/AddC',
          icon:'icon-bell'
        },
        {
          name:'Add Keyboard Question',
          url:'/Questions/AddK',
          icon:'icon-bell'
        },
        {
          name:'Add Multiple Choice Question',
          url:'/Questions/AddMC',
          icon:'icon-bell'
        },{
          name:'Add Energy Balance Question',
          url:'/Questions/AddEBQ',
          icon:'icon-bell'
        },
        {
          name:'Add Diagrams Question',
          url:'/Questions/AddDQ',
          icon:'icon-bell'
        },{
          name:'Add FBD Question',
          url:'/Questions/AddFBDQ',
          icon:'icon-bell'
        },
        {
          name:'Questions List',
          url:'/Questions/List',
          icon:'icon-list'
        }
      ]
    
    }

  ],
};

export const course_content_nav = {
  items: [
    {
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'icon-speedometer',
     
    },
    {
      name: 'Datapools',
      icon: 'icon-lock',
      url: '/Settings',     
    },
    {
      name: 'Profile/Colleagues',
      icon: 'icon-user',
      url: '/colleagues',     
    },
    {
      name: 'Reports',
      icon: 'icon-list',
      url: '/Reports',     
    },
    
    {
      name: 'Courses',
      icon: 'icon-bell',
      children: [
        {
          name: 'Add Course',
          url: '/Courses/Add',
          icon: 'icon-bell',
        },
        {
          name: 'Add Course Map',
          url: '/Courses/AddCourseMap',
          icon: 'icon-bell',
        },
        {
          name: 'Courses List',
          url: '/Courses/List',
          icon: 'icon-list',
        }
      ],
    },
    {
      name: 'Notifications',
      icon: 'icon-bell',
      url: '/Notifications',     
    },{
      name: 'Student feedback',
      icon: 'icon-share-alt',
      url: '/StudentFeedback',     
    },
    {
      name: 'Information',
      icon: 'icon-calculator',
      children: [
        {
          name:'Add information',
          url:'/Information/Add',
          icon:'icon-bell'
        },{
          name:'Information list',
          url:'/Information/List',
          icon:'icon-list'
        },{
          name:'Add background image',
          url:'/Information/AddBI',
          icon:'icon-bell'
        },{
          name:'Background images',
          url:'/Information/ListBI',
          icon:'icon-list'
        },{
          name:'Add map element image list',
          url:'/Information/AddMEIL',
          icon:'icon-bell'
        },{
          name:'Map element image lists',
          url:'/Information/ListMEIL',
          icon:'icon-list'
        },{
          name:'Add Default Question Image',
          url: '/Questions/AddDefaultImage',
          icon:'icon-bell'
        },{
          name:'Default Question Image List',
          url: '/Questions/DefaultQuestionImagesList',
          icon:'icon-list'
        },{
          name:'Add Series Icons',
          url: '/Information/AddSeriesIcons',
          icon:'icon-bell'
        }]
    },
    {
      name: 'Click Image Trees',
      url: '/ClickImageAnswers',
      icon: 'icon-pie-chart',
    },
    {
      name: 'Interpreted Images',
      url: '/ClickInterpretedImageAnswers',
      icon: 'icon-star'
    },
    {
      name: 'Topics',
      url: '/Topics',
      icon: 'icon-star'
    },
    {
      name: 'Keyboard',
      icon: 'icon-calculator',
      children: [
        {
          name:'Add Keyboard',
          url:'/Keyboard/AddKeyboard',
          icon:'icon-bell'
        },
        {
          name:'Add Key List',
          url:'/Keyboard/AddKeyList',
          icon:'icon-bell'
        },
        {
          name: 'Add Key',
          url: '/Keyboard/AddKey',
          icon: 'icon-bell',
        },
        {
          name: 'Keys',
          url: '/Keyboard/KeysList',
          icon: 'icon-list',
        },
        {
          name: 'Keyboards List',
          url: '/Keyboard/KeyboardsList',
          icon: 'icon-list',
        },
        {
          name:'Keys Lists',
          url:'/Keyboard/KeysListList',
          icon:'icon-list'
        }
      ]
    
    },
    {
      name: 'Questions',
      icon: 'icon-calculator',
      children: [
        {
          name:'Add Clickable Question',
          url:'/Questions/AddC',
          icon:'icon-bell'
        },
        {
          name:'Add Keyboard Question',
          url:'/Questions/AddK',
          icon:'icon-bell'
        },
        {
          name:'Add Multiple Choice Question',
          url:'/Questions/AddMC',
          icon:'icon-bell'
        },{
          name:'Add Energy Balance Question',
          url:'/Questions/AddEBQ',
          icon:'icon-bell'
        },{
          name:'Add Diagrams Question',
          url:'/Questions/AddDQ',
          icon:'icon-bell'
        },{
          name:'Add FBD Question',
          url:'/Questions/AddFBDQ',
          icon:'icon-bell'
        },
        {
          name:'Add Question Series',
          url:'/Questions/AddQuestionSeries',
          icon:'icon-bell'
        },
        {
          name:'Questions List',
          url:'/Questions/List',
          icon:'icon-list'
        },
        {
          name:'Questions Series List',
          url:'/Questions/QuestionSeriesList',
          icon:'icon-list'
        },
      ]
    
    }

  ],
};
